import {Injectable} from '@angular/core';
import {BuildingStructure} from "../model/building-structure";
import {StructureNode} from "./structure-node";
import {StructureService} from "../structure.service";

@Injectable()
export class TreeResolver {

  constructor(
      private readonly structureResource: StructureService,
  ) { }

  public async treeFor(structureId: number) {

    console.group('Loading Issue structure');
    let structure = await this.detailsFor(structureId);
    let node = { structure: structure } as StructureNode;
    let iterationCount = 0;
    console.log('Got details for issue structure', structure);
    while (Number.isFinite(structure.parentStructureId)) {
      iterationCount++;
      console.group('Not at Building level yet, resolving parent …')
      structure = await this.resolveParentOf(structure);
      console.log('Found parent', structure);
      node = {
        child: node,
        structure,
      } as StructureNode;
      if (iterationCount > 10) {
        throw new RangeError('Traversing structure tree exceeded nesting limit of 10');
      }
    }
    while (iterationCount > 0 ) {
      console.groupEnd();
      iterationCount--;
    }
    console.log('Completed structure', node);
    console.groupEnd();
    return node;
  }

  public async sequenceFor(structureId?: number) {
    const tree = await this.treeFor(structureId);
    return this.flatten(tree);
  }

  public flatten(rootNode: StructureNode) {
    let node = rootNode;
    const flattenedStructure = [node.structure] as BuildingStructure[];
    while (node.child) {
      node = node.child;
      flattenedStructure.push(node.structure);
    }
    console.log('Flattened', flattenedStructure);
    return flattenedStructure;
  }

  private async resolveParentOf(structure: BuildingStructure) {
    return this.detailsFor(structure.parentStructureId);
  }

  private detailsFor(structureId: number) {
    return this.structureResource.detailsFor(structureId).toPromise();
  }
}
